const letterSpacings = {
  tighter: '-0.05rem',
  tight: '-0.025rem',
  normal: '0',
  wide: '0.025rem',
  wider: '0.05rem',
  widest: '0.1rem',
  xs: '0.056rem',
  medium: '0.192rem',
} as const;

export default letterSpacings;
